// extracted by mini-css-extract-plugin
export var content = "PlusUpsell-module__content___WLMOP";
export var logo = "PlusUpsell-module__logo___t3Lbc";
export var feature = "PlusUpsell-module__feature___O2Zlo";
export var features = "PlusUpsell-module__features___NWEFz";
export var subtext = "PlusUpsell-module__subtext___t_2vi";
export var button = "PlusUpsell-module__button___OhD7Q";
export var title = "PlusUpsell-module__title___bM8nV";
export var header = "PlusUpsell-module__header____XsSm";
export var close = "PlusUpsell-module__close___sUdZP";